/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNiAxNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMCAxMy45OUwxMC4zNTI5IDE0QzEwLjk4MzUgMTQgMTEuNTQ4MiAxMy42NyAxMS44ODcxIDEzLjE2TDE2IDdMMTEuODg3MSAwLjg0QzExLjU0ODIgMC4zMyAxMC45ODM1IDAgMTAuMzUyOSAwTDAgMC4wMTAwMDAyTDQuNTU1MjkgN0wwIDEzLjk5WiIgLz48L3N2Zz4=";